"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DocumentVirusScanStatus () {
        return DocumentVirusScanStatus;
    },
    get EditDocumentRequest () {
        return EditDocumentRequest;
    },
    get EditDocumentResponse () {
        return EditDocumentResponse;
    },
    get GetManageableDocumentEmployeesResponse () {
        return GetManageableDocumentEmployeesResponse;
    },
    get ManageableDocumentEmployee () {
        return ManageableDocumentEmployee;
    },
    get UpdateDocumentVirusScanStatusResponse () {
        return UpdateDocumentVirusScanStatusResponse;
    }
});
const _zod = require("zod");
const DocumentVirusScanStatus = _zod.z.enum([
    "clean",
    "no-tag",
    "unsafe"
]);
const UpdateDocumentVirusScanStatusResponse = _zod.z.object({
    virusScanStatus: DocumentVirusScanStatus
});
const EditDocumentRequest = _zod.z.object({
    filename: _zod.z.string().optional(),
    tags: _zod.z.array(_zod.z.string()).optional(),
    vis_to_everyone: _zod.z.boolean().optional(),
    vis_to_man: _zod.z.boolean().optional(),
    vis_to_emp: _zod.z.boolean().optional(),
    allow_ai_retrieval: _zod.z.boolean().optional()
});
const EditDocumentResponse = _zod.z.object({
    filename: _zod.z.string(),
    taskId: _zod.z.string().nullable()
});
const ManageableDocumentEmployee = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string()
});
const GetManageableDocumentEmployeesResponse = _zod.z.object({
    employees: _zod.z.array(ManageableDocumentEmployee),
    canManageAllEmployees: _zod.z.boolean()
});
